
export default [
    {
        path: '/course/topic',
        name: 'Cousertopic',
        component: () => import('../views/course/topic'),
        meta:{
            title:'练习'
        }
    },
    {
        path: '/course/exercises',
        name: 'Couserexercises',
        component: () => import('../views/course/exercises'),
        meta:{
            title:'练习'
        }
    },
    {
        path: '/course/history',
        name: 'Couserhistory',
        component: () => import('../views/course/history'),
        meta:{
            title:'历史列表'
        }
    },
    {
        path: '/course/review',
        name: 'Couserereview',
        component: () => import('../views/course/review'),
        meta:{
            title:'历史回看'
        }
    },
    {
        path: '/course/play',
        name: 'play',
        component: () => import('../views/play/Index'),
        meta:{
            title:'播放'
        }
    },
]